import { AppStateEnum } from '../../../../../main/types/app-state.types.ts';

import { updateAppStateThunk } from '../../../../slices/app-state/thunks/update-app-state.thunk.ts';
import { completeStepThunk } from '../../../../slices/progress/thunks/complete-step.thunk.ts';

import { BaseAppStateChangeHandlerUtil } from '../base-app-state-change.handler.ts';

export class StoryAppSayStateChangeHandlerUtil extends BaseAppStateChangeHandlerUtil {
  private static _instance: StoryAppSayStateChangeHandlerUtil;

  public static get instance(): StoryAppSayStateChangeHandlerUtil {
    if (!StoryAppSayStateChangeHandlerUtil._instance) {
      StoryAppSayStateChangeHandlerUtil._instance = new StoryAppSayStateChangeHandlerUtil();
    }
    return StoryAppSayStateChangeHandlerUtil._instance;
  }

  protected getHandlerName(): string {
    return 'StoryAppSay';
  }

  protected override async onReadyToStart(): Promise<void> {
    await super.onReadyToStart();
    console.log(`${this.getHandlerName()} onReadyToStart`);

    // Speak step
    await this.audioPlayerUtil.speakStep();
    await this.audioPlayerUtil.waitSpeakCompletion();

    // Move to next step blocking animations
    const dispatch = await this.reduxStoreUtil.getDispatch();

    dispatch(completeStepThunk());
    await dispatch(updateAppStateThunk({ state: AppStateEnum.MoveToNextStep, blockAnimation: true }));
  }
}

export const getStoryAppSayStateChangeHandlerUtil = (): StoryAppSayStateChangeHandlerUtil =>
  StoryAppSayStateChangeHandlerUtil.instance;
